import { EntityIconMd } from '@components/core-ui/EntityIcon/variations/EntityIconMd';
import { AdminGetOrganizationResponseDto } from 'app/API';
import { OrgImageBlock } from './styles/OrgImageBlock';

type TProps = {
  org: AdminGetOrganizationResponseDto;
  viewOnly?: boolean;
};

export const OrganizationImageViewOnly = ({ org }: TProps) => {
  return (
    <OrgImageBlock>
      <EntityIconMd name={org.name} src={org.image ?? undefined} />
    </OrgImageBlock>
  );
};
